import { IFeatureRequest } from "../../freelo";
import { IConverter, TSnapshot } from "../generics";

export const featureRequestConverter: IConverter<IFeatureRequest> = {
  toFirestore(featureRequest: Omit<IFeatureRequest, "id">) {
    return { ...featureRequest };
  },
  fromFirestore(snapshot: TSnapshot): IFeatureRequest {
    const data = snapshot.data() as IFeatureRequest;
    return {
      id: snapshot.id,
      title: data?.title,
      description: data?.description,
      priority: data?.priority,
      status: data?.status,
      projectId: data?.projectId,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
      clientId: data?.clientId,
      attachments: data?.attachments,
      requestedById: data?.requestedById,
      assignedToId: data?.assignedToId,
      comments: data?.comments,
      freeloTicketIds: data?.freeloTicketIds,
      freeloBoardId: data?.freeloBoardId,
      desiredStartDate: data?.desiredStartDate,
      desiredCompletionDate: data?.desiredCompletionDate,
      clientEstimatedHours: data?.clientEstimatedHours,
      clientDollarAmountBudget: data?.clientDollarAmountBudget,
      actualStartDate: data?.actualStartDate,
      actualCompletionDate: data?.actualCompletionDate,
      freetechEstimatedHours: data?.freetechEstimatedHours,
      freetechEstimatedDollarAmount: data?.freetechEstimatedDollarAmount,
      completedAt: data?.completedAt,
      requestDate: data?.requestDate,
      approvedByAdminUserId: data?.approvedByAdminUserId,
      approvedByAdminDate: data?.approvedByAdminDate,
      rejectedByAdminUserId: data?.rejectedByAdminUserId,
      rejectedByAdminDate: data?.rejectedByAdminDate,
    };
  },
};
